import { styled } from "@mui/material";
import MainCard from "../cards/MainCard";
// import { colors } from "../../utility/constant";

interface CardWrapperProps {
  backgroundcolor?: string; // Add additional custom props as needed
}

export const CardWrapper = styled(MainCard)<CardWrapperProps>(
  ({ theme, backgroundcolor }) => ({
    backgroundColor: backgroundcolor || theme.palette.primary.main,
    color: "#fff",
    overflow: "hidden",
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: backgroundcolor || theme.palette.primary.main,
      borderRadius: "50%",
      top: -85,
      right: -95,
      [theme.breakpoints.down("sm")]: {
        top: -105,
        right: -140,
        backgroundColor: backgroundcolor || theme.palette.primary.main,
      },
    },
    "&:before": {
      content: '""',
      position: "absolute",
      width: 210,
      height: 210,
      background: backgroundcolor || theme.palette.primary.main,
      borderRadius: "50%",
      top: -125,
      right: -15,
      opacity: 0.5,
      [theme.breakpoints.down("sm")]: {
        top: -155,
        right: -70,
        backgroundColor: "",
      },
    },

    [theme.breakpoints.down("sm")]: {
      margin: theme.spacing(3), // or use margin: theme.spacing(2)
      // ... other styles for small screens
    },
  })
);
